import PoliciesApi from '../api/rest/directus-cms/policys';
import { PolicyType } from '../api/rest/directus-cms/policys/response/PolicyResponse';
import { cookiesPolicyData, privacyPolicyData } from '../stores/stores';
export async function fetchCookiesPolicy(lang) {
    await PoliciesApi.getInstance()
        .getCookiePolicy(lang, PolicyType.COOKIES_POLICY)
        .then(response => {
        cookiesPolicyData.set(response);
    })
        .catch(error => {
        console.log('Error fetching Cookies Policy', error);
    });
}
export async function fetchPrivacyPolicy(lang) {
    await PoliciesApi.getInstance()
        .getCookiePolicy(lang, PolicyType.PRIVACY_POLICY)
        .then(response => {
        privacyPolicyData.set(response);
    })
        .catch(error => {
        console.log('Error fetching Cookies Policy', error);
    });
}
